var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDoubleArrowRight = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.286526 7.75651C0.120312 7.92275 0.120312 8.19224 0.286526 8.35848C0.452732 8.52463 0.722206 8.52463 0.888412 8.35848L4.29322 4.95362C4.45944 4.78742 4.45944 4.51794 4.29322 4.35174L0.888412 0.946926C0.722206 0.780712 0.452732 0.780712 0.286526 0.946926C0.120312 1.11313 0.120312 1.38261 0.286526 1.54881L3.39039 4.65268L0.286526 7.75651ZM5.39374 7.75651C5.22753 7.92275 5.22753 8.19224 5.39374 8.35848C5.55995 8.52463 5.82942 8.52463 5.99563 8.35848L9.40048 4.95362C9.56664 4.78742 9.56664 4.51794 9.40048 4.35174L5.99563 0.946926C5.82942 0.780712 5.55995 0.780712 5.39374 0.946926C5.22753 1.11313 5.22753 1.38261 5.39374 1.54881L8.49761 4.65268L5.39374 7.75651Z",
    fill: "#9BA5AE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoubleArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/double_arrow_right.2387bd63.svg";
export { ForwardRef as ReactComponent };